import { L } from '@lib';
import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import React, { memo } from 'react';

const { Option } = Select;

interface IProps {
  onChange?:
    | ((value: string, option?: DefaultOptionType | DefaultOptionType[] | undefined) => void)
    | undefined;
}

export const ActivitySelect: React.FC<IProps> = memo(({ onChange }) => {
  return (
    <Select style={{ width: 100 }} defaultValue="All" onChange={onChange}>
      <Option value={undefined}>{L('All')}</Option>
      <Option value={1}>{L('Active')}</Option>
      <Option value={0}>{L('Inactive')}</Option>
    </Select>
  );
});
